export default "__VITE_ASSET__D1ox1q8y__"